import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { ProductService } from '@services/products/product.service';

import * as _ from 'lodash';
import moment from 'moment';

@Component({
  selector: 'app-dynamic-content-action',
  template: '',
  providers: [DynamicContentEntranceService, DynamicContentService, ProductService],
  standalone: false
})
export class DynamicContentActionComponent {
  constructor(public dynamicContentEntranceService: DynamicContentEntranceService,) {}

  public static checkValid(content) {
    if (content) {
      const ibexPublishing = {
        published: content.published,
        weekdays: content.weekdaysInterval,
        publishstart: content.publishStart,
        publishfinish: content.publishEnd
      };
      if (content.dailyIntervalPublish) {
        ibexPublishing['timeframestart'] = content.dailyIntervalPublish.start;
        ibexPublishing['timeframefinish'] = content.dailyIntervalPublish.end;
      }
      return this.isValid(ibexPublishing);
    } else {
      return false;
    }
  }

  static isValid(publishing) {
    const now = new Date();

    if (!this.weekdaysValid(publishing.weekdays)) {
      return false;
    }

    if (!publishing.publishstart && !publishing.publishfinish) {
      return true;
    }

    if (!!publishing.publishstart && moment(publishing.publishstart).toDate().getTime() > now.getTime()) {
      return false;
    }

    if (!!publishing.publishfinish && moment(publishing.publishfinish).toDate().getTime() < now.getTime()) {
      return false;
    }

    if (!!publishing.timeframestart) {
      const tfs = publishing.timeframestart.split(':');

      if (+tfs[0] > now.getHours()) {
        return false;
      }
      if (+tfs[0] === now.getHours() && +tfs[1] > now.getMinutes()) {
        return false;
      }
      // we silently ignore the seconds :)
    }

    if (!!publishing.timeframefinish) {
      const tff = publishing.timeframefinish.split(':');

      if (+tff[0] < now.getHours()) {
        return false;
      }
      if (+tff[0] === now.getHours() && +tff[1] < now.getMinutes()) {
        return false;
      }
    }

    return true;
  }

  static weekdaysValid(weekdays): boolean {
    if (weekdays === null || weekdays === undefined) {
      return true;
    }

    const days = [];
    if (!_.isArray(weekdays)) {
      weekdays = _.values(weekdays);
    }

    for (let i = 0; i < weekdays.length; i++) {
      days[weekdays[i]] = true;
    }

    return days[new Date().getDay()];
  }
}
